module.exports = __webpack_public_path__ + "media/images/icon-logo-facebook@3x-8a96582b2bdf6663c491b20880e570ba.png";